import { NEWS_ITEMS } from '@/mocks/home';

export default function WhatsNew() {
  return (
    <section id="news" className="bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <div className="text-center">
          <span className="text-xs font-semibold uppercase tracking-[0.2em] text-accent-600">Latest Updates</span>
          <h2 className="mt-3 font-heading text-3xl font-extrabold text-primary-800 md:text-4xl">What&apos;s New</h2>
          <div className="mx-auto mt-4 h-1 w-20 rounded-full bg-accent-500"></div>
        </div>

        <div className="mt-12 grid grid-cols-1 gap-6 md:grid-cols-2">
          {NEWS_ITEMS.map((n) => (
            <article
              key={n.title}
              className="flex flex-col overflow-hidden rounded-lg border border-primary-700 bg-primary-800 p-8"
            >
              <span className="inline-flex w-fit items-center gap-2 rounded-full bg-accent-500 px-3 py-1 text-xs font-semibold text-background-50">
                <i className="ri-bookmark-3-line"></i> {n.tag}
              </span>
              <h3 className="mt-5 font-heading text-2xl font-bold text-background-50">{n.title}</h3>
              <p className="mt-4 flex-1 text-sm leading-relaxed text-secondary-200">{n.text}</p>
              <a
                href="#news"
                className="mt-6 inline-flex w-fit items-center gap-2 whitespace-nowrap rounded-md border border-secondary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-accent-500 hover:border-accent-500"
              >
                Read More <i className="ri-arrow-right-line text-[18px]"></i>
              </a>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}